export default __webpack_public_path__ + "static/reglement interieur Francais-c5c7611e278c2f6c653ea9e84f6897bb.pdf";